<ng-template #modalTemplate>
  <aran-modal
    [templateRef]="modalfields"
    [modalTitle]="'Confirmation'"
    [modalAction]="{
    showActions: false,
  }"
  ></aran-modal>

  <ng-template #modalfields>
    <form [formGroup]="form" (ngSubmit)="forgotPswConfirm()">
      <div
        fxLayout="row wrap"
        class="form-fields"
        fxLayoutAlign="space-between center"
      >
        <aran-input
          class="w-full"
          type="text"
          label="Enter Code"
          formControlName="code"
          [errorMessages]="{
            required: errorMessages.required('Code'),
          }"
        ></aran-input>

        <div fxFlex="100%" class="confirmation-form">
          <aran-button
            [type]="'submit'"
            [name]="'Confirm'"
            [disabled]="!form.get('code')?.value"
            [className]="!form.get('code')?.value ? 'btn_disabled' : ''"
          ></aran-button>
        </div>
      </div>
    </form>
  </ng-template>
</ng-template>

<div class="forgotpsw-container">
  <div>
    <h1 class="forgotpsw-container__title">Forgot Password</h1>
    <p class="forgotpsw-container__desc">Define new password</p>
    <form
      [formGroup]="form"
      (ngSubmit)="reset()"
      fxLayout="column"
      fxLayoutAlign="center"
    >
      <aran-input
        type="text"
        placeholder="Enter your email"
        label="Email"
        formControlName="email"
        [readonly]="verified"
        [errorMessages]="{
          required: errorMessages.required('Email'),
          email: errorMessages.email
        }"
      ></aran-input>

      <app-input-psw-criteria
        *ngIf="verified"
        type="password"
        placeholder="Enter your password"
        label="Password"
        formControlName="password"
        [obscure]="true"
        [criteriaList]="criteriaList"
        [errorMessages]="{
          required: errorMessages.required('Password'),
          minlength: errorMessages.minlength(8),
          ascii: errorMessages.ascii,
          weak: errorMessages.weak
        }"
        (enterPressed)="onEnterPressed()"
      >
      </app-input-psw-criteria>

      <aran-input
        *ngIf="verified"
        type="password"
        placeholder="Retype your password"
        label="Confirm Password"
        formControlName="confirmPassword"
        [obscure]="true"
        [errorMessages]="{
          required: errorMessages.required('Confirm Password'),
          passwordMismatch: errorMessages.notMatch
        }"
        (enterPressed)="onEnterPressed()"
      ></aran-input>

      <div class="mt-5">
        <aran-button
          class="w-full"
          [type]="'submit'"
          [name]="verified ? 'Reset' : 'Continue'"
          [disabled]="!form.valid"
        ></aran-button>
      </div>

      <div class="forgotpsw-container__redirect-register mt-5">
        <span class="forgotpsw-container__redirect-register--question"
          >Back to your account?</span
        >
        <a
          [routerLink]="[routeMetaData.login.link]"
          class="forgotpsw-container__redirect-register--link"
          >{{ routeMetaData.login.title }}</a
        >
      </div>
    </form>
  </div>
</div>
